import LogRocket from 'logrocket'
import {
  type Business,
  SentryUtils,
  type User,
  Utils,
} from '@pbt/pbt-ui-components'

import LogRocketSanitizer from './LogRocketSanitizer'
import {
  registerTrackingProvider,
  setSessionInfo,
  TrackingEvent,
} from './trackingProvider'

const KEYS: Record<string, string> = {
  Play: 'w2huxx/rhapsody-portal-master',
  Production: 'w2huxx/rhapsody-portal-prod',
  Staging: 'w2huxx/rhapsody-portal-stage-3orpw',
}

export const initLogRocket = () => {
  const environment = Utils.getEnvironmentName()
  const key = KEYS[environment]
  if (key) {
    const { requestSanitizer, responseSanitizer } = LogRocketSanitizer

    LogRocket.init(key, {
      release: process.env.REACT_APP_SENTRY_RELEASE || '0.0.0',
      network: {
        requestSanitizer,
        responseSanitizer,
      },
      mergeIframes: true,
    })

    LogRocket.getSessionURL((sessionURL) => {
      SentryUtils.configureSentrySessionURL(sessionURL)
    })

    // Register LogRocket as a click tracker
    registerTrackingProvider({
      track: (eventName, meta) => {
        LogRocket.track?.(eventName, meta)
      },
    })
  }
}

export const setLogRocketUser = (
  user: User,
  business?: Business,
  userRoles?: string[],
) => {
  if (!LogRocket || !user) {
    return
  }
  LogRocket.identify(user.id, {
    name: Utils.getPersonString(user),
    email: user.email || '',
  })
  setSessionInfo({
    business: business?.id || '',
    businessType: business ? (business?.omniChannel ? 'CVC' : '3P') : '',
    businessName: business?.name || '',
    userName: Utils.getPersonString(user),
    userId: user.id || '',
    userEmail: user.email || '',
    userRoles: userRoles?.join(', ') || '',
  })
  LogRocket.track(TrackingEvent.SESSION_INFO, {
    roles: userRoles?.join(', ') || '',
    business: business?.id || '',
    businessType: business ? (business?.omniChannel ? 'CVC' : '3P') : '',
    businessName: business?.name || '',
  })
}

export const resetLogRocketUser = () => {
  if (!LogRocket) {
    return
  }
  LogRocket.identify('null')
}

export const getLockRocketSessionURL = () => LogRocket?.sessionURL || undefined
